import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Maintenance } from './pages/Maintenance';
import { InternalTraffic } from './pages/InternalTraffic';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3k9ui96ixzq9y">
      <Routes data-id="element-1" data-mp="3k92om18wo2mb">
        <Route path="/internal/traffic" element={<InternalTraffic data-id="element-3" data-mp="3farhvzdwq88b" />} data-id="element-2" data-mp="3k8t7l35u95sr" />
        {/*
          Every other URL renders the maintenance page AT the requested path —
          matching how the edge should serve a 503 — so telemetry records the page
          the visitor actually wanted (/jobs, /dashboard/payments, …).
         */}
        <Route path="*" element={<Maintenance data-id="element-5" data-mp="31ayr642drs0c" />} data-id="element-4" data-mp="31aqeoda66opo" />
      </Routes>
    </BrowserRouter>;
}